import { z } from 'zod';

export const passkeyCredentialSchema = z.object({
  id: z.string(),
  deviceType: z.string().optional(),
  backedUp: z.boolean().optional(),
  nickname: z.string().nullable().optional(),
  createdAt: z.coerce.date(),
});

export type PasskeyCredentialSchema = z.infer<typeof passkeyCredentialSchema>;
